import { TranslateLoader } from '@ngx-translate/core';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from './offlineApi.service';
import { BaseService } from './baseService';
import { AppConstants } from '../../utils/appConstants.class';

export function ApiLoaderFactory(offlineApi: OfflineApiService) {
  return new ApiTranslateLoader(offlineApi);
}

export class ApiTranslateLoader extends BaseService implements TranslateLoader {
  constructor(private offlineApi: OfflineApiService) {
    super();
  }

  public getTranslation(lang: string, prefix: string = '/inspectionreport/i18n/'): any {
    return this.offlineApi.getWithMode(
      `${prefix}${lang}`,
      this.isConnection ? ApiMode.OnlineSave : ApiMode.Offline,
      AppConstants.INDEXEDDB_TABLES.translations,
      lang
    );
  }
}
